import { useLocation } from 'react-router'
import AcceptInvitation from '../../pages/AcceptInvitation'
import { useAcceptInvitation } from '../../hooks/useAcceptInvitation'

function AcceptInvitationWrapper(props) {
  const location = useLocation()
  const {
    loaded,
    loadingError,
    confirmed,
    confirmationError,
    name,
    email,
    isUserActive,
    disabledForm,
    confirm,
  } = useAcceptInvitation()

  return (
    <AcceptInvitation
      location={location}
      siteKey={props.siteKey || ''}
      loaded={loaded}
      loadingError={loadingError}
      confirmed={confirmed}
      confirmationError={confirmationError}
      name={name}
      email={email}
      isUserActive={isUserActive}
      disabledForm={disabledForm}
      onLoad={() => {}}
      onConfirm={({ password, passwordConfirmation, recaptchaResponse }) =>
        confirm({ password, passwordConfirmation, recaptchaResponse })
      }
      onExecuteRecaptcha={() => {}}
    />
  )
}

export default AcceptInvitationWrapper
